import { TFunction } from 'i18next'
import groupBy from 'lodash/groupBy'
import isEmpty from 'lodash/isEmpty'
import { Price } from '@omnea-app/requests/price'
import { CurrencyCode } from 'utils/currency/getCurrencyCodes'
import { CoreDataCurrency } from 'utils/currency/hooks/useOrganisationCurrencies'
import { getPriceFrequencyLabel } from 'utils/price/getPriceFrequencyLabel'
import { getAmountInDefaultCurrency } from 'utils/price/getPriceInDefaultCurrency'
import { Dictionary } from 'utils/utiltyTypes/utilityTypes'

type Input = {
  termLabel: string
  prices: Price[] | null | undefined
  defaultCurrency?: CurrencyCode
  currenciesByCode?: Dictionary<CoreDataCurrency>
  t: TFunction<'requests'>
}

export const getPriceValue = ({ termLabel, prices, defaultCurrency, currenciesByCode, t }: Input): string => {
  if (prices == null) return ''

  const grouped = groupBy(prices, 'termIndex')
  const termEntries = Object.entries(grouped).sort(([a], [b]) => Number(a) - Number(b))

  const multipleTerms = termEntries.length > 1

  const termStrings = termEntries
    .map(([termIndex, pricesInTerm]) => {
      const amounts = pricesInTerm
        .map((price) => {
          const amount = getAmountInDefaultCurrency({ price, defaultCurrency, currenciesByCode })
          if (amount === undefined) return amount

          const frequencyLabel =
            price.paymentInterval != null
              ? getPriceFrequencyLabel({ multiYears: price.multiYears, paymentInterval: price.paymentInterval, t })
              : undefined
          if (isEmpty(frequencyLabel)) return String(amount)

          return `${amount} ${frequencyLabel}`
        })
        .filter((a): a is string => typeof a === 'string')

      if (amounts.length === 0) return null

      const amountsStr = amounts.join(' / ')
      return multipleTerms ? `${termLabel} ${Number(termIndex) + 1}: ${amountsStr}` : amountsStr
    })
    .filter((s): s is string => typeof s === 'string')

  return termStrings.length ? termStrings.join(' | ') : ''
}
